export default __webpack_public_path__ + "static/blob-26-a48a83e4c6f2855b830e484c7b1fa2fa.svg";